import { useRoute } from 'vue-router';
import { createInjection } from 'src/lib/createInjection';
import { computed } from 'vue';
import type { ComputedRef } from 'vue';

type PageTypeContext = {
  isGuestPage: ComputedRef<boolean>;
  isPrintPage: ComputedRef<boolean>;
  isSpPage: ComputedRef<boolean>;
};

const { provide, inject } = createInjection<PageTypeContext>('usePageType');

const GUEST_PAGE_NAMES: ReadonlyArray<string> = ['Login'];

export const providePageType = (): PageTypeContext => {
  const route = useRoute();

  const isSpPage = computed<boolean>(() => {
    // route.name ではなく route.path で判定することで /sp/ 配下を網羅する
    return route.path.startsWith('/sp/');
  });

  const isGuestPage = computed<boolean>(() => {
    if (!route.name) return false;
    return GUEST_PAGE_NAMES.includes(String(route.name));
  });

  const isPrintPage = computed<boolean>(() => {
    return typeof route.name === 'string' && route.name.startsWith('Print');
  });

  const context: PageTypeContext = { isGuestPage, isPrintPage, isSpPage };
  provide(context);
  return context;
};

export const usePageType = (): PageTypeContext => {
  return inject();
};
